import { Component, Input, OnInit } from "@angular/core";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { EmailSettingsDto } from "@dashboard/modules/management/email/models/email-settings.dto";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";

@Component({
  selector: "kl-email-settings",
  templateUrl: "./email-settings.component.html",
  styleUrls: ["./email-settings.component.scss"],
})
export class EmailSettingsComponent implements OnInit {
  @Input() entity: EmailSettingsDto = new EmailSettingsDto();
  @Input() isReadOnly: boolean;
  @Input() tabId: string;
  @Input() modalId: string;
  use_ssl: boolean;
  alertShow = false;
  alertMessage = "";
  alertType = "";
  testMailFormNotValid: boolean;
  requiredError: boolean;
  showIndicator: boolean;
  mailSendSuccess: boolean;
  mailSendError: boolean;
  isOpenFirstAccordion = true;
  mail = {
    to: "",
    title: "",
    body: "",
  };

  constructor(
    private apiService: ApiService,
    private klLoadingService: KlLoadingService,
    private explorerService: ExplorerService,
    private utilService: UtilService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.apiService
      .getFilteredData("mail-server", { filter: { type: "OUTGOING" } })
      .subscribe(
        (response) => {
          if (response.data === undefined) {
            this.handleError("error_data", "alertShow");
          } else {
            if (response.data.length > 0) {
              this.entity = response.data[0];
              this.entity.user_name = UtilService.decryptString(
                this.entity.user_name
              );
              this.entity.password = UtilService.decryptString(
                this.entity.password
              );
              this.use_ssl = this.entity.use_ssl === "YES";
            } else {
              this.entity.type = "OUTGOING";
              this.entity.timeout = 10;
            }
          }
        },
        (error) => this.handleError(error, "alertShow")
      );
  }

  commitSave() {
    this.klLoadingService.show("saving");
    this.alertShow = false;
    this.mailSendSuccess = false;
    this.mailSendError = false;
    const data = {
      id: this.entity.id ? this.entity.id : null,
      type: this.entity.type,
      timeout: this.entity.timeout,
      send_address: this.entity.send_address,
      host_name: this.entity.host_name,
      port_number: this.entity.port_number,
      use_ssl: this.use_ssl ? "YES" : "NO",
      user_name: UtilService.encryptString(this.entity.user_name),
      password: UtilService.encryptString(this.entity.password),
    };
    this.apiService.addData("mail-server", data).subscribe(
      () => {
        this.toastService.toastSuccess();
        this.klLoadingService.hide();
        if (this.tabId) {
          this.explorerService.closeTab(this.tabId);
        } else if (this.modalId) {
          this.explorerService.closeModal(this);
        }
      },
      (error) => this.handleError(error, "alertShow")
    );
  }

  sendTestMail() {
    this.isReadOnly = true;
    this.showIndicator = true;
    this.testMailFormNotValid = false;
    const sendMailObj = {
      body: this.mail.body,
      type: this.entity.type,
      timeout: this.entity.timeout,
      host_name: this.entity.host_name,
      port_number: this.entity.port_number,
      send_address: this.entity.send_address,
      use_ssl: this.use_ssl ? "YES" : "NO",
      password: UtilService.encryptString(this.entity.password),
      user_name: UtilService.encryptString(this.entity.user_name),
      title: this.mail.title,
      to: this.mail.to,
    };
    this.apiService.addData("mail-server/testmail", sendMailObj).subscribe(
      () => {
        this.mailSendSuccess = true;
        this.alertType = "success";
        this.alertMessage = this.utilService.alertErrorMessage(
          "test_mail_send_success_message"
        );
      },
      (error) => this.handleError(error, "alertShow")
    );
  }

  handleError(error, errorType) {
    this.alertType = "error";
    this[errorType] = true;
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
  }
}
